import React, {Fragment, useEffect, useState} from 'react'
import '../pages/OnboardingScreen/OnboardingScreen.scss'
import {MDBCard, MDBCardBody} from "mdbreact";
import {withRouter} from 'react-router-dom';
import Slider from "react-slick";
import {SwipeEventListener} from 'swipe-event-listener';
import {Slide, Zoom, Fade} from 'react-reveal';
import confetti from 'canvas-confetti'
import {assetUrl} from "../serviceApi";
import {isJwtExpired} from "jwt-check-expiration";

const whiteArrow = assetUrl + "images/onboarding-white-right-arrow.svg";
const purpleArrowRight = assetUrl + 'images/arrow-right-s-line.png'
const smallForwardArrow = assetUrl + 'images/onboarding_forwardbutton_icon.svg'
const smallBackwardArrow = assetUrl + 'images/onboarding_backbutton_icon.svg'
const fav_politician = assetUrl + "images/fav_politician.png";
const portfolio = assetUrl + "images/onboarding-tray-briefcase-new.png";
const prizes = assetUrl + "images/topPlayer.png";
const topPlayerRaising = assetUrl + 'images/onboard_leaderboard_popUP_2.png'
const polls_1 = assetUrl + 'images/polls_1_blue.png'
const polls_2 = assetUrl + 'images/poll_2_yellow.png'
const polls_3 = assetUrl + 'images/polls_3_violet.png'
const shadow = assetUrl + 'images/onboarding_animation_chart_shaddow.png'

const OnboardingScreenComponent = (props) => {
	const {stylePrefix, countRef, setState} = props
	const [endConfetti, setEndConfetti] = useState(false);
	const [dataSet, setDataSet] = useState([
		//collateral - onboard slide-01 | reassigned

		{
			id: 0,
			icon: fav_politician,
			heading: "Politicians Ka Share Market",
			text: "Buy shares of politicians who you think will grow in value",
			largerComponent: false
		},
		{
			id: 1,
			icon: portfolio,
			heading: "Earn as Your Neta Shares Grow",
			text: "If your shares grow overtime, you can cash out winnings",
			largerComponent: false
		}, {
			id: 2,
			icon: polls_1,
			icon2: polls_2,
			icon3: polls_3,
			heading: 'Keep Politicians Responsible',
			text: "Politicians will work better if they know their value is monitored",
			largerComponent: false
		}, {
			id: 3,
			icon: prizes,
			heading: "Compete with Rest of India",
			text: "Track where you rank in the country for your political intelligence",
			largerComponent: true,
			button1: "Get Started", button2: "Log In "
		}]);
	const [trigger, setTrigger] = useState(false)

//next slide changer
	const nextClickHandler = () => {
		// debugger
		// collateral - onboard slide-01 | reassigned
		if (
			countRef.current <= (dataSet.length - 1) &&
			countRef.current !== 4) {

			setTrigger(false)
			countRef.current = countRef.current + 1;
			setState(countRef.current)

			setTrigger(true)
		}
	}
	//previous slide changer
	const prevClickHandler = () => {
		if (countRef.current > 0) {
			setTrigger(false)
			countRef.current = countRef.current - 1;
			setState(countRef.current)

			setTrigger(true)
		}

	}
//login page redirector
	const goToLoginPage = () => {
		let token = localStorage.getItem("token")
		if (token) {
			let checkifExpire = isJwtExpired(token)
			if (checkifExpire) {
				localStorage.clear()
				props.history.push("/login");
			} else {
				props.history.push("/home");
			}
			console.log("checkifExpire", checkifExpire)

		} else {
			localStorage.clear()
			props.history.push("/login");
		}

		setState(countRef.current)

	}

	// animation trigger handler
	useEffect(() => {
		setTrigger(true)
		return () => {
			setTrigger(false)
		};
	}, [trigger]);

	// navigation handlers
	useEffect(() => {
		//swiper area declartion
		const {swipeArea, updateOptions} = SwipeEventListener({
			swipeArea: document.querySelector('.onboarding-component'),
		});
		//swipe left handler
		swipeArea.addEventListener('swipeLeft', () => {

			setTrigger(false)
			// collateral - onboard slide-01 | reassigned
			// debugger
			if (countRef.current < 3) {
				countRef.current = countRef.current + 1;
				setState(countRef.current)
			}

			setTrigger(true)

		});
		// swipe right handler
		swipeArea.addEventListener('swipeRight', () => {

			if (countRef.current > 0) {
				setTrigger(false)
				countRef.current = countRef.current - 1;
				setState(countRef.current)

				setTrigger(true)
			}

		});
		//  button-next1 event handler
		if (document.querySelector("#button-next1")) {

			document.querySelector("#button-next1").addEventListener("click", (e) => {
				// debugger
				let x = e.clientX;
				let y = e.clientY;
				let buttonTop = e.target.offsetTop;
				let buttonLeft = e.target.offsetLeft;
				let xInside = x - buttonLeft;
				let yInside = y - buttonTop;

				let circle = document.createElement('span');
				circle.classList.add('circle');
				// circle.style.top = yInside + 'px';
				circle.style.left = xInside + 'px';
				// if (document.querySelector("#button-next1")) {

				// document.querySelector("#button-next1").appendChild(circle);
				//
				// setTimeout(() => {
				//
				// 	circle.remove();
				//
				// }, 100);
				// setTimeout(() => {
				// 	nextClickHandler();
				// }, 300);

				// }
			});
		}

		return () => {
			// swipeArea.removeEventListener("swipeLeft", () => console.log('listener removed'))
			// swipeArea.removeEventListener("swipeRight", () => console.log('listener removed'))
			if (document.querySelector("#button-next1")) {
				document.querySelector("#button-next1").removeEventListener("click", () => {
					// console.log("removed listern")
				})
			}

		};
	}, [countRef]);

	//  button-next1 event handler
	useEffect(() => {
		if (document.querySelector("#button-next")) {
			document.querySelector("#button-next").addEventListener("click", (e) => {
				let x = e.clientX;
				let y = e.clientY;
				let buttonTop = e.target.offsetTop;
				let buttonLeft = e.target.offsetLeft;
				let xInside = x - buttonLeft;
				let yInside = y - buttonTop;

				let circle = document.createElement('span');
				circle.classList.add('circle');
				// circle.style.top = yInside + 'px';
				circle.style.left = xInside + 'px';
				if (document.querySelector("#button-next")) {
					document.querySelector("#button-next").appendChild(circle);
					document.querySelector("#button-next").classList.add("onboard-button-B-focus")
					setTimeout(() => {

						circle.remove();

					}, 500);

					setTimeout(() => {

						// dataSet[countRef].button2 === "Log In " ?
						goToLoginPage()
						// : nextClickHandler();
					}, 100);

				}
			});
		}
		return () => {
			if (document.querySelector("#button-next")) {
				document.querySelector("#button-next").removeEventListener("click", () => document.querySelector("#button-next").classList.remove("onboard-button-B-focus"))
			}
		};
	}, [countRef.current]);

	//Carousel settings
	const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		loop: false,
		slidesToScroll: 1
	};
	// confetti animation handler
	//collateral - onboard slide-01 | reassigned
	// if (countRef.current === 3 && !endConfetti) {
	// 	setTimeout(() => {
	// 		setEndConfetti(true)
	// 	}, 2000)
	// 	setTimeout(() => {
	// 		confetti()
	// 	}, 1000)
	//
	// }

	return (
		<div className={"onboarding-component"}>
			{/*<Slider {...settings} >*/}
			{/*    {dataSet.map((items) => {*/}
			{/*        return <div key={items.id} style={{height:'100vh'}}>*/}
			{/*{dataSet[count] !== undefined?*/}
			<div className={stylePrefix + "background" + " onboard-step-" + countRef.current}
			     style={{width: '100vw', zIndex: 5}}>
				<MDBCard
					className={stylePrefix + 'cardStyle'}>
					{/*//collateral - onboard slide-01 | reassigned*/}
					{countRef.current === 3 &&
					<img src={topPlayerRaising} alt={"alt"} className={stylePrefix + "top-player-raising"}/>}
					<MDBCardBody className="onboard-step-section">
						{/*//collateral - onboard slide-01 | reassigned*/}
						{!(countRef.current === 3) && <p className={"skip-button "} onClick={goToLoginPage}>Skip</p>}
						<Slider {...settings} >
							{
								dataSet.map((items) => {

									return <Fragment key={items.id}>
										<div
											className={"d-flex justify-content-between flex-column"}
											style={{minHeight: "288px"}}
										>

											{/*<Slide right cascade when={trigger}>*/}
											<div className={stylePrefix + 'textWrapper mx-auto text-center'}>

												<div className={stylePrefix + "iconwrap text-center"}>
													{
														// collateral - onboard slide-01 | reassigned
														countRef.current === 2 ?
															<div className="colors_coin_valley my-2"
															     style={{
																     height: "80px",

															     }}>
																<div className="violet_insert_image2">
																	{/*<Fade top delay={1000}>*/}
																	<img src={polls_3} alt="alt"/>
																	{/*</Fade>*/}
																</div>
																<div className="violet_insert_image1">
																	{/*<Fade delay={1000}>*/}
																	<img src={polls_1} alt="alt"/>
																	{/*</Fade>*/}
																</div>
																<img src={polls_2} alt="alt"
																     className={"violet_insert_image text-center"}/>

																<img src={shadow} alt="alt"
																     className="shadow_image text-center"/>

															</div>
															:
															// countRef.current === 1 ?
															// <div
															// 	className={stylePrefix + "imageWrapper-portfolio mx-auto"}>
															// 	<img alt={"alt"} src={portfolio}
															// 	     className={stylePrefix + "breifcase"}/>
															// 	{/*<Spin  delay={300}>*/}
															// 	<img alt={"alt"} src={star}
															// 	     className={stylePrefix + "star"}/>
															// 	{/*</Spin>*/}
															// </div> :

															// <Zoom delay={300}>
															<>
																<img alt={"alt"}
																     src={dataSet[countRef.current].icon}
																     className={stylePrefix + 'icons mb-3 mx-auto'}/>
																{/*</Zoom>*/}</>

													}

												</div>

												<p className={stylePrefix + 'heading mb-2'}> {dataSet[countRef.current].heading}</p>
												<p className={stylePrefix + "textParagraph"}> {dataSet[countRef.current].text}</p>

											</div>
											{/*</Slide>*/}

											<div className={stylePrefix + "buttonWrapper"}>
												<div
													className={!dataSet[countRef.current].largerComponent ? 'dot-wrap-aligner' : "dot-wrap-aligner-2"}>
													<div
														className={stylePrefix + 'dotWrapper d-flex justify-content-center my-2 '}>
														{
															// collateral - onboard slide-01 | reassigned
															[0, 1, 2, 3].map((item, index) => {
																return <div
																	className={item !== countRef.current ? stylePrefix + 'dot mx-1' : stylePrefix + 'dotClicked mx-1'}
																	key={index}/>
															})
														}
													</div>
												</div>

												{dataSet[countRef.current].largerComponent ?
													<div className={'d-flex justify-content-center '}>
														<button
															className={stylePrefix + "button-A d-flex justify-content-center align-items-center  px-3 py-3 m-1"}
															onClick={goToLoginPage}
														>
															{dataSet[countRef.current].button1} <span><img
															src={whiteArrow} className={"ml-2"}
															alt={'alt'}/></span>
														</button>

														<button id={"button-next"}
														        className={dataSet[countRef.current].button2 === "Log In " ? stylePrefix + "button-B d-flex justify-content-center align-items-center  px-3 py-3 mx-1 my-1" : stylePrefix + "button-A d-flex justify-content-center align-items-center  px-3 py-3 my-1\n" +
															        "my-1 mx-1"} onClick={goToLoginPage}
															// onClick={dataSet[count].button2 === "Log In " ? goToLoginPage : nextClickHandler}
														>
															{dataSet[countRef.current].button2} {
															countRef.current === 0 ?

																<span><img src={whiteArrow} alt={'alt'}/></span> :
																<span><img src={purpleArrowRight} alt={'alt'}/></span>
														}
														</button>
													</div>
													:
													<div className={'d-flex justify-content-between mx-3 my-2'}>

														<button id={"button-prev"}
														        className={stylePrefix + "buttonSmall-A  p-0 "}
														        style={{
															        width: "10vw !important",
															        visibility: countRef.current !== 0 ? "visible" : "hidden"
														        }}
														        onClick={prevClickHandler}>
															<img src={smallBackwardArrow} alt={"back"}/>
														</button>

														<button
														        className={stylePrefix + "buttonSmall-B  p-0 "}
														        style={{width: "10vw !important"}}
														         onClick={nextClickHandler}
														>
															<img id={"button-next1"} src={smallForwardArrow} alt={"back"}/>
														</button>
													</div>
												}

												<div className={'text-center'}>
													{/*<hr className={stylePrefix + "horizontalLine my-1"}/>*/}
												</div>
											</div>
										</div>
									</Fragment>
								})
							}
						</Slider>

					</MDBCardBody>
				</MDBCard>
			</div>
			{/*:<h1>Loading</h1>}*/}

		</div>

	)
};

export default withRouter(OnboardingScreenComponent);
